import type { Components } from '@mui/material/styles';

export default function MUIStepConnector(): Components['MuiStepConnector'] {
  return {};
}
